import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { AuthData, User } from '../models';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/utils/services/storage.service';
import { BehaviorSubject } from 'rxjs';

const URL_API = environment.urlApi;

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  user: User | undefined;
  $user: BehaviorSubject<User | null> = new BehaviorSubject<User | null>(null);

  constructor(private http: HttpClient, private storage: StorageService) { }

  async loadUser() {

    this.user = await this.http.get<User>(`${URL_API}/auth/loadUser`).toPromise();

    if (!this.user) {
        this.removeToken();
        return;
      }

      this.$user.next(this.user);
  }

  
  setUserLoad(user: User) {
    this.$user.next(user);
    this.user = user;
  }


  setUserData(userData: any) {
    localStorage.setItem("user_data", JSON.stringify(userData));
  }

  login (email: string, password: string) {
    return this.http.post<AuthData>(`${URL_API}/auth/login`, { email: email, password: password });
  } 

  refreshToken(tokenData: AuthData) {
    return this.http.post(`${URL_API}/auth/refresh-token`,
      {
        refreshToken: tokenData.refreshToken
      });
  }

  getToken() {
    let data = this.storage.get('SESSION_ID');
    if (data) {
      return JSON.parse(data);
    } else {
      return null;
    }
  }

  isAuthenticated() {

    let user = this.$user.getValue()
    if (user) {
      return true;
    }
    if (user == null) { return false; }
    if (Object.keys(user).length === 0) { return false; }
    return user != null;
  }

  isLogged = () =>  this.getToken() !== null;

  setToken = (authData: AuthData) =>  this.storage.set('SESSION_ID', JSON.stringify(authData));

  removeToken = () => {
    this.storage.remove('SESSION_ID');
    this.storage.remove('lastOrganization');
  };

  logOut = (authData: AuthData | null) => this.http.post(`${URL_API}/auth/logout`, { refreshToken: authData?.refreshToken });

  getActiveOrganization() {
    const organizationName = this.storage.get('lastOrganization');
    return this.user?.organizations.find(o => o.name === organizationName);

  }

}
